import { SkuInfoListProps } from "../SkuInfoList";

const skuInfoListConfig: SkuInfoListProps = {
  size: 'small',
  rowKey: 'bskuMappingSkuItemId',
  skuItemDataKey: 'mappingSkuItemList',
  imageFieldName: 'productSkuInfo.skuImageFullUrl',
  imageTootipFieldName: 'bskuName',
  skuItemMaxLength: 1,
  addonBeforeLabel: 'SKU数量:',
  addonBeforeFieldname: 'quantity',
  bskuOptions: [
    {
      label: '业务商品编码',
      name: 'bskuCode',
      isCopy: true,
      valueMaxWidth: 110,
    },
    {
      label: '类型',
      name: 'bskuType',
      enumCode: 'BSKU_TYPE',
      hiddenTooltip: true,
    },
    {
      label: '卖家',
      name: 'merchantName',
    },
  ],
  skuOptions: [
    {
      mergeColumn: true,
      config: [
        {
          name: 'productSkuInfo.skuSpecName',
        },
        {
          name: 'productInfo.productName',
        },
      ],
    },
    {
      config: [
        {
          name: 'productSkuInfo.skuCode',
          label: 'SKU',
          isCopy: true,
        },
        {
          name: 'productSkuInfo.customizeSkuCode',
          label: '自定义SKU',
          isCopy: true,
        },
        {
          name: 'productInfo.productCode',
          label: '货号',
          isCopy: true,
        },
        {
          name: 'productInfo.customizeProductCode',
          label: '自定义货号',
          isCopy: true,
        },
      ],
    },
  ],
};

export default skuInfoListConfig;